import mermaid from 'mermaid'

mermaid.initialize({
  startOnLoad: false,
  securityLevel: 'strict',
  theme: 'default',
  fontFamily: 'monospace',
  flowchart: { useMaxWidth: false },
  sequence: { useMaxWidth: false },
  class: { useMaxWidth: false },
  state: { useMaxWidth: false },
  er: { useMaxWidth: false },
  gantt: { useMaxWidth: false },
  journey: { useMaxWidth: false },
  pie: { useMaxWidth: false }
})

let idCounter = 0

export const nextMermaidId = () => `skx-mermaid-${idCounter++}`

export const MERMAID_ZOOM = {
  minScale: 0.2,
  maxScale: 8,
  step: 0.2,
  resetAnimationMs: 200
}
